import { CountCellProps } from '../../types';

const TotalOnReplicaDatabaseCountsCell = ({
  _customRowProps,
  data: { countsOnServer },
}: CountCellProps) => {
  return <div>{countsOnServer ?? ''}</div>;
};

export default TotalOnReplicaDatabaseCountsCell;
